<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="notice_type"
                    label="通知类型"
                    prop="notice_type"
                    :extra="formErr.notice_type"
                    :validateStatus='!formErr.notice_type||formErr.notice_type==""?"":"error"'
            >
                <a-select v-model="form.notice_type">
                    <a-select-option :key="item.value" :value="item.value" v-for="item in noticeList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="name"
                    label="发件人名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=50
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="email"
                    label="邮箱"
                    prop="email"
                    :help="formErr.email"
                    :validateStatus='!formErr.email||formErr.email==""?"":"error"'
            >
                <a-input  :maxLength=50
                        v-model="form.email"
                        @change="(e) => { formErr.email=''}"
                        @blur="(e) => {  form.email = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="username"
                    label="用户名"
                    prop="username"
                    :help="formErr.username"
                    :validateStatus='!formErr.username||formErr.username==""?"":"error"'
            >
                <a-input  :maxLength=50
                        v-model="form.username"
                        @change="(e) => { formErr.username=''}"
                        @blur="(e) => {  form.username = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="password"
                    label="密码"
                    prop="password"
                    :help="formErr.password"
                    :validateStatus='!formErr.password||formErr.password==""?"":"error"'
            >
                <a-input-password
                        :maxLength=20
                        v-model="form.password"
                        @change="(e) => {formErr.password=''}"
                        @blur="(e) => {form.password = e.target.value.trim();formErr.password='' }"
                />
                <span v-if="form.id&&form.id!=''" style="position: absolute;width: 100%;left: 0;top:20px;text-align: right">输入则修改密码，否则密码与原始密码相同</span>
            </a-form-model-item>
            <a-form-model-item
                    ref="smtp_server"
                    label="SMTP服务器"
                    prop="smtp_server"
                    :help="formErr.smtp_server"
                    :validateStatus='!formErr.smtp_server||formErr.smtp_server==""?"":"error"'
            >
                <a-input  :maxLength=50
                          v-model="form.smtp_server"
                          @change="(e) => { formErr.smtp_server=''}"
                          @blur="(e) => {  form.smtp_server = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="connect_type"
                    label="连接方式"
                    prop="connect_type"
                    :extra="formErr.connect_type"
                    :validateStatus='!formErr.connect_type||formErr.connect_type==""?"":"error"'
            >
                <a-select v-model="form.connect_type">
                    <a-select-option :value="item.value" :key="item.value" v-for="item in typeList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="smtp_port"
                    label="SMTP服务器端口"
                    prop="smtp_port"
                    :help="formErr.smtp_port"
                    :validateStatus='!formErr.smtp_port||formErr.smtp_port==""?"":"error"'
            >
                <a-input  :maxLength=10
                          v-model="form.smtp_port"
                          @change="(e) => { formErr.smtp_port=''}"
                          @blur="(e) => {  form.smtp_port = e.target.value.trim() }"
                />
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    let pattern=/[^\u4e00-\u9fa5]/
    export default {
        name: "notificationForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig ,
                noticeList:[],
                typeList:[],
                form: {
                    email:"",
                    smtp_server:"",
                    username:"",
                    notice_type:1,
                    name:"",
                    password:"",
                    connect_type:1,
                    smtp_port:"",
                },
                formErr: {
                    email:"",
                    smtp_server:"",
                    username:"",
                    notice_type:"",
                    name:"",
                    password:"",
                    connect_type:"",
                    smtp_port:"",
                },
                rules: {
                    smtp_port:[{required: true, message: "请输入SMTP服务器端口 ",  }, {pattern:/^\d{1,}$/,message: "只能填写数字"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.smtp_port)}  , trigger: "blur"  },],
                    smtp_server:[{required: true, message: "请输入SMTP服务器 ",  }, { whitespace: true, message: "请输入SMTP服务器 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.smtp_server)}  , trigger: "blur"  },],
                    name: [{required: true, message: "请输入发件人名称 ",  },{pattern:pattern,message: "请填写正确发件人名称"}, { whitespace: true, message: "请输入发件人名称 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                    username: [{required: true, message: "请输入用户名称 ",  },{type:"email",message: "请填写正确用户名"}, { whitespace: true, message: "请输入用户名称 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.username)}  , trigger: "blur"  },],
                    password: [{required: true, message: "请输入密码 ",  },{pattern:pattern,message: "请填写正确密码"}, {  whitespace: true, message: "请输入密码 " },{min:6,max:20,message: "请填写6-20个字符"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.password)}  , trigger: "blur"  }, ],
                    email: [{required: true, message: "请输入邮箱 ",  }, { whitespace: true, message: "请输入邮箱 " },{type:"email",message: "请输入正确邮箱"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.email)}  , trigger: "blur"  },  ],

                },
                layout: {
                    labelCol: { span: 5},
                    wrapperCol: { span: 14 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.notificationEmail.GET_EDIT_FORM(a).then(res => {
                        let val = res.data.data.info
                        this.form.id=a
                        this.smtp_port=val.smtp_port
                        this.form.password=""
                        this.rules.password= [{required: false, message: "请输入密码 ",  } ,{min:6,max:20,message: "请填写6-20个字符"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.password)}  , trigger: "blur"  }, ],
                        this.form = val

                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
            this.getFormData()
        },
        methods: {
            getFormData(){
                API.notificationEmail.GET_FORMDATA().then(res => {
                    this.noticeList = res.data.data.notice_type
                    this.typeList = res.data.data.connect_type
                })
            },
            onClose() {
                this.$emit("changVisible", false);
                this.form.password=""
                this.formErr={  email:"", smtp_server:"", username:"", notice_type:"", name:"", password:"", connect_type:"", smtp_port:"",},
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.notificationEmail.SUBMIT_ADD : url = API.notificationEmail.SUBMIT_EDIT

                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
